import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnedriveFolderIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7188 6.25L10.6139 5.14516C10.3209 4.85211 9.92344 4.6875 9.50904 4.6875H2.34375C1.91227 4.6875 1.5625 5.03727 1.5625 5.46875V20.0521C1.5625 20.1959 1.67909 20.3125 1.82292 20.3125H23.1771C23.3209 20.3125 23.4375 20.1959 23.4375 20.0521V7.03125C23.4375 6.59977 23.0877 6.25 22.6562 6.25H11.7188Z",
			fill: "#FFB900"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7188 6.25L10.6139 7.35484C10.3209 7.64789 9.92344 7.8125 9.50904 7.8125H1.5625V20.0521C1.5625 20.1959 1.67909 20.3125 1.82292 20.3125H23.1771C23.3209 20.3125 23.4375 20.1959 23.4375 20.0521V7.03125C23.4375 6.59977 23.0877 6.25 22.6562 6.25H11.7188Z",
			fill: "#FFD75E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7188 6.25L10.6139 7.35484C10.3209 7.64789 9.92344 7.8125 9.50904 7.8125H1.5625V20.0521C1.5625 20.1959 1.67909 20.3125 1.82292 20.3125H23.1771C23.3209 20.3125 23.4375 20.1959 23.4375 20.0521V7.03125C23.4375 6.59977 23.0877 6.25 22.6562 6.25H11.7188Z",
			fill: "url(#paint0_linear_12410_61975)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M1.5625 7.8125V8.07292H9.53138C10.0148 8.07292 10.4785 7.88086 10.8204 7.53898L12.1094 6.25H11.7188L10.6139 7.35484C10.3209 7.64789 9.92344 7.8125 9.50904 7.8125H1.5625Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.1771 20.3125H1.82292C1.67909 20.3125 1.5625 20.1959 1.5625 20.0521H23.4375C23.4375 20.1959 23.3209 20.3125 23.1771 20.3125Z",
			fill: "#DA7B16"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_12410_61975",
			x1: 12.5,
			y1: 6.25,
			x2: 12.5,
			y2: 20.3125,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "white",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFD75E",
				stopOpacity: .3
			})]
		}) })
	]
});
export default SvgOnedriveFolderIcon;
